import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./assets/style.css";
import { auth, db } from "./firebase";

import firebase from "firebase/compat/app";

const Chapter6_1 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was ist ein wichtiger Vorteil der Cloud-Nutzung für Unternehmen?",
      options: [
        {
          value: "A",
          label:
            "Die Cloud ist kostenlos und daher für Unternehmen finanziell vorteilhaft.",
        },
        {
          value: "B",
          label:
            "Skalierbarkeit – Unternehmen können ihre IT-Ressourcen je nach Bedarf flexibel erweitern oder reduzieren.",
        },
      ],
      correct: "B",
    },
    {
      question:
        "Frage 2: Was ist ein Merkmal bei der Cloud-Nutzung für die Zusammenarbeit in Teams?",
      options: [
        {
          value: "A",
          label:
            "Die Cloud ermöglicht es mehreren Nutzern gleichzeitig auf dieselben Dateien zuzugreifen und in Echtzeit zusammenzuarbeiten.",
        },
        {
          value: "B",
          label:
            "In der Cloud kann immer nur eine Person auf Dateien zugreifen.",
        },
      ],
      correct: "A",
    },
  ];

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 6_1.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "6_1",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("6_1"),
            });
          console.log("Dokument aktualisiert mit Kapitel 6_1.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "6_1",
              completedChapters: ["6_1"],
            });
          console.log("Dokument erstellt mit Kapitel 6_1");
        }

        navigate("/6_2"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  5. Sicheres Cloud Computing
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Was ist die Cloud?
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 6: Sicheres Cloud Computing
          </h3>
          <h2 className="text-center p-3">Was ist die Cloud ?</h2>
          <img
            src="/images/cloudcomputing.png"
            alt="Cloud"
            style={{ position: "relative", maxWidth: "50%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-4">Was ist die Cloud?</h2>
          <p className="col-lg-11 mx-auto">
            Durch die Cloud-Technologie muss man Daten und Anwendungen nicht
            mehr lokal auf dem Computer oder in einem firmeneigenen
            Rechenzentrum speichern, stattdessen nutzt man via Internet die
            Infrastruktur von Server, die in weltweit verteilten Rechenzentren
            stehen.
            <br />
            <br /> Es gibt verschiedene <strong> Bereitstellungsmodelle </strong>
            von Cloud-Infrastrukturen:
          </p>

          <h4 className="pt-5">Public Cloud</h4>
          <p className="pt-3 col-lg-11 mx-auto">
            Bei der Public Cloud stellt ein externer Anbieter (z. B. Amazon Web
            Services, Microsoft Azure oder Google Cloud) IT-Ressourcen wie
            Server, Speicherplatz und Anwendungen über das Internet für mehrere
            Kunden zur Verfügung. Die Ressourcen werden
            <strong> gemeinsam genutzt, </strong> aber jeder Kunde hat seine
            eigenen isolierten Bereiche. <br /><br />
            Die Infrastruktur wird vollständig vom Anbieter verwaltet und
            gewartet. Eine Public Cloud ist kosteneffizient und schnell
            skalierbar.
           
            Einsatzbeispiele: Webhosting, App-Entwicklung, Cloud-Speicher (z. B.
            Google Drive).
          </p>
          <h4 className="pt-5">Private Cloud </h4>
          <p className="pt-3 col-lg-11 mx-auto">
            Die Private Cloud wird ausschließlich
            <strong> von einer einzelnen Person oder einem Unternehmen </strong> genutzt. Sie kann entweder
            im eigenen Rechenzentrum (on-premises) oder durch einen externen
            Anbieter betrieben werden, aber die Ressourcen werden ausschließlich
            für diesen einzelnen Nutzer/Kunden bereitgestellt. Dieses Modell bietet{" "}
            <strong>
              {" "}
              mehr Kontrolle, Sicherheit und Anpassungsfähigkeit{" "}
            </strong>{" "}
            und wird daher oft von Organisationen verwendet, die hohe
            Anforderungen an Datenschutz und Compliance haben.
            <br />
            Einsatzbeispiele: Finanzdienstleister, Behörden, Gesundheitssektor.
          </p>
          <h4 className="pt-5">Hybrid Cloud </h4>
          <p className="pt-3 col-lg-11 mx-auto">
            {" "}
            Die Hybrid Cloud ist eine Mischung aus Public und Private Cloud.
            Unternehmen nutzen eine Kombination aus eigenen (privaten) und
            externen (public) Cloud-Ressourcen und können Daten oder Anwendungen
            zwischen beiden Umgebungen verschieben. Sie sind damit{" "}
            <strong> maximal flexibel und anpassungsfähig. </strong>Unternehmen
            können so z. B. die kostengünstige Public Cloud für allgemeine
            Anwendungen nutzen, während sensible Daten in der Private Cloud mit
            mehr Sicherheit und Kontrolle gespeichert werden. <br />
            Einsatzbeispiele: Unternehmen, die temporäre hohe Auslastungen
            haben, z. B. in der Softwareentwicklung oder im E-Commerce.
          </p>

          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Die "Cloud" ist nicht wirklich immateriell oder unsichtbar, wie der
            Name suggeriert. Tatsächlich besteht die Cloud aus physischen
            Rechenzentren, die auf der ganzen Welt verteilt sind. Einige dieser
            Rechenzentren sind riesige Einrichtungen (oft so groß wie mehrere
            Fußballfelder), die tausende, rund um die Uhr laufende Server
            betreiben. Diese großen Cloud-Anbieter wie Amazon, Google und
            Microsoft haben natürlich einen enormen Energieverbrauch. Daher wird
            die Energieeffizienz der Rechenzentren immer wichtiger. Viele
            Anbieter setzen mittlerweile auf grüne Energie oder bauen
            Rechenzentren in kalte Regionen, um die Kühlkosten zu senken.
          </p>
        </div>
      </div>

      <div className="white-section">
        <div className="container">
          <div className="text-center">
            <h3 className="pb-3">
              Vorteile von Cloud-Computing für Unternehmen
            </h3>
            <p>
              <section class="p-5 text-start">
                <ul class="timeline">
                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">1. Kosteneffizienz: </h5>

                    <p>
                      <ul>
                        <li>
                          <strong>Reduzierte Investitionskosten </strong>
                          Unternehmen müssen keine teure Hardware kaufen oder
                          eigene Rechenzentren betreiben. Sie zahlen nur für die
                          tatsächlich genutzten Ressourcen
                          (Pay-as-you-go-Modell).
                        </li>{" "}
                        <br />
                        <li>
                          <strong>Niedrige Betriebskosten: </strong>
                          Wartung, Updates und Sicherheitsmaßnahmen werden vom
                          Cloud-Anbieter übernommen, was die internen IT-Kosten
                          senkt.
                        </li>{" "}
                      </ul>
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">2. Skalierbarkeit</h5>

                    <p>
                      <ul>
                        <li>
                          <strong>Flexibler Ressourcenverbrauch: </strong>{" "}
                          Unternehmen können ihre Ressourcen (z. B.
                          Speicherplatz, Rechenleistung) je nach Bedarf erhöhen
                          oder verringern. Das ist besonders nützlich bei
                          saisonalen Schwankungen oder unvorhergesehenem
                          Wachstum.
                        </li>{" "}
                        <br />
                        <li>
                          <strong>Globale Verfügbarkeit: </strong> Cloud-Dienste
                          sind weltweit verfügbar und ermöglichen es
                          Unternehmen, schnell in neue Märkte zu expandieren.
                        </li>
                      </ul>
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">3. Mobilität und Zusammenarbeit </h5>

                    <ul>
                      <li>
                        <strong>Ortsunabhängiger Zugriff: </strong> Mitarbeiter
                        können von überall aus auf Daten und Anwendungen
                        zugreifen – ein Vorteil für Remote-Arbeit und mobile
                        Teams.
                      </li>
                      <li>
                        <strong>Verbesserte Zusammenarbeit: </strong>{" "}
                        Cloud-Tools wie Microsoft 365 oder Google Workspace
                        ermöglichen Echtzeit-Kollaboration und vereinfachen die
                        gemeinsame Arbeit an Projekten.
                      </li>
                    </ul>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">4. Sicherheit und Zuverlässigkeit </h5>

                    <p>
                      <ul>
                        {" "}
                        <li>
                          <strong>
                            Fortschrittliche Sicherheitslösungen:{" "}
                          </strong>{" "}
                          Cloud-Anbieter investieren massiv in
                          Sicherheitsmaßnahmen wie Verschlüsselung, Firewalls
                          und regelmäßige Updates, um Daten vor Angriffen zu
                          schützen.
                        </li>{" "}
                        <li>
                          <strong>Datensicherung: </strong> Automatische Backups
                          und Disaster-Recovery sorgen dafür, dass Daten bei
                          Ausfällen schnell wiederhergestellt werden können.
                        </li>{" "}
                        <li>
                          <strong>Höhere Verfügbarkeit: </strong> Cloud-Systeme
                          garantieren oft eine Betriebszeit von über 99,9%, was
                          die Zuverlässigkeit gegenüber anderen Lösungen deutlich erhöht.
                        </li>
                      </ul>
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">5. Innovation und Agilität</h5>

                    <p>
                      <ul>
                        <li>
                          <strong>Schneller Zugang zu Technologien: </strong>
                          Cloud-Computing bietet Zugang zu neuesten Technologien
                          wie künstlicher Intelligenz, Machine Learning und Big
                          Data-Analysen, ohne hohe Anfangsinvestitionen.
                        </li>
                        <li>
                          <strong>Schnelle Bereitstellung: </strong>Neue
                          Anwendungen oder Dienste können innerhalb weniger
                          Minuten bereitgestellt werden, wodurch Entwicklungs- und
                          Innovationszyklen beschleunigt werden.
                        </li>
                      </ul>
                    </p>
                  </li>
                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">6. Umweltfreundlichkeit</h5>

                    <p>
                      <ul>
                        <li>
                          <strong>Effiziente Ressourcennutzung: </strong>
                          Cloud-Anbieter betreiben stark optimierte Rechenzentren,
                          die weniger Energie verbrauchen als lokale Server.
                        </li>
                        <li>
                          <strong>Geteilte Infrastruktur: </strong>Durch das
                          Teilen von Rechenressourcen können Unternehmen ihren
                          ökologischen Fußabdruck reduzieren.
                        </li>
                      </ul>
                    </p>
                  </li>
                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">7. Wettbewerbsfähigkeit</h5>

                    <p>
                      <ul>
                        <li>
                          <strong>Fokus auf Kernkompetenzen: </strong>Da die
                          IT-Infrastruktur und deren Wartung ausgelagert werden,
                          können sich Unternehmen auf ihre strategischen Ziele
                          und Innovationen konzentrieren.
                        </li>
                        <li>
                          <strong>Zugang für kleine Unternehmen: </strong>Auch
                          kleine und mittelständische Unternehmen können
                          Cloud-Dienste nutzen, um von Technologien zu
                          profitieren, die früher nur Großunternehmen
                          vorbehalten waren.
                        </li>
                      </ul>
                    </p>
                  </li>
                </ul>
              </section>
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              97% der deutschen Unternehmen mit mindestens 50 Beschäftigten
              vertrauen auf Cloud-Computing. Die meisten Unternehmen nutzen
              dabei hybride Modelle, bei denen Public- und Private-Cloud-Dienste
              parallel eingesetzt werden. (KPMG 2023)
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="pt-5 container">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">Herausforderungen der Cloud</h3>
            <p className="col-lg-11 mx-auto">
              So groß die Vorteile der Cloud auch sind: Es gibt auch einige
              Herausforderungen, die zu beachten sind.
              <br />
              <br />
              <strong>Sicherheitsbedenken: </strong> Einer der größten
              Kritikpunkte an der Cloud ist die Sicherheit. Da Daten in der
              Cloud auf Servern von Drittanbietern gespeichert werden, besteht
              das Risiko, dass sie von Unbefugten abgefangen oder manipuliert
              werden.
              <br />
              <br />
              <strong>
                {" "}
                Abhängigkeit vom Anbieter (Vendor Lock-in):{" "}
              </strong>{" "}
              Wenn man sich einmal für einen bestimmten Cloud-Anbieter
              entschieden hat, kann es schwierig und teuer werden, später zu
              einem anderen Anbieter zu wechseln. Diese Abhängigkeit kann die
              Flexibilität einschränken und die Kosten erhöhen, wenn sich die
              Geschäftsbedingungen oder die Preise des Anbieters ändern. Eine
              sorgfältige Planung und die Nutzung von Multi-Cloud-Strategien
              können helfen, dieses Risiko zu minimieren.
              <br />
              <br />
              <strong>Compliance und rechtliche Herausforderungen: </strong>
              Die Einhaltung von Datenschutzgesetzen und branchenspezifischen
              Vorschriften kann in der Cloud komplizierter sein als in
              traditionellen IT-Umgebungen. Dies gilt besonders, wenn Daten in
              verschiedenen Ländern gespeichert werden, die unterschiedlichen
              rechtlichen Rahmenbedingungen unterliegen. Unternehmen müssen
              sicherstellen, dass sie die gesetzlichen Anforderungen in allen
              Ländern, in denen sie tätig sind, erfüllen. Dies erfordert oft
              spezielle Compliance-Maßnahmen und Zertifizierungen.
              <br />
              <br />
              <strong>Performance und Latenz: </strong>
              Die Leistung von Cloud-Diensten kann variieren. Sie oft von
              der Qualität der Internetverbindung ab. Latenzprobleme können
              auftreten, wenn die Entfernung zwischen dem Anwender und dem
              Cloud-Rechenzentrum zu groß ist. Dies kann insbesondere bei
              Echtzeitanwendungen problematisch sein. Unternehmen müssen
              sicherstellen, dass sie geeignete Maßnahmen ergreifen, um die
              Performance zu optimieren, etwa durch den Einsatz von{" "}
              <span
                data-tooltip-id="tooltip-cdn"
                data-tooltip-content="Ein CDN verteilt Kopien von Inhalten auf mehrere geografisch verteilte Server, sodass die Daten schneller von einem näher gelegenen Standort abgerufen werden können.
              "
                className="custom-tooltip-trigger"
              >
                Content Delivery Networks (CDNs){" "}
              </span>{" "}
              oder{" "}
              <span
                data-tooltip-id="tooltip-caching"
                data-tooltip-content="Caching speichert häufig verwendete Daten lokal oder an einem nahegelegenen Punkt, sodass diese Daten schneller verfügbar sind, ohne jedes Mal über große Entfernungen abgerufen werden zu müssen.
              "
                className="custom-tooltip-trigger"
              >
                lokalen Caching-Lösungen.{" "}
              </span>{" "}
              <br />
              <br />
              <strong>Komplexität der Integration: </strong>
              Die Integration von Cloud-Diensten in oder mit bestehenden
              IT-Systemen kann komplex sein. Insbesondere bei hybriden Lösungen
              müssen Unternehmen sicherstellen, dass alle Systeme nahtlos
              zusammenarbeiten. Dies erfordert eine sorgfältige Planung und
              möglicherweise auch Anpassungen an die bestehende
              IT-Infrastruktur.
            </p>
            <ReactTooltip
              id="tooltip-cdn"
              place="top"
              className="custom-tooltip"
            />
            <ReactTooltip
              id="tooltip-caching"
              place="top"
              className="custom-tooltip"
            />
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-9 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Ende Fragenteil */}
      </div>
    </div>
  );
};

export default Chapter6_1;
